import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ConfigDataService } from '../../services/config-data.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslatorService } from '../../services/translator.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent {
     //baseURL: string = process.env.APP_PRE_PEND;
     apiUrl:string = environment.NODE_ENV;

     username: string = '';
     loginGovUrl: string = '';
     gettingDates: boolean = false;
     routeParams: ParamMap = {} as ParamMap;
     viewPage: boolean = true;
     isLoading: boolean = false;

     constructor (public configDataService: ConfigDataService,
          private route: ActivatedRoute,
          public generalService: GeneralService,
          public _router: Router,
          public translatorService: TranslatorService) {
     }
    
     ngOnInit(): void {
          this.routeParams = this.route.snapshot.queryParamMap;
          this.translatorService.restoreBackupLanguage();

          //check if the user is logging in from login.gov
          const isLoggingIn = this.generalService.getIsLoggingIn();
          if (isLoggingIn != null) {
               this.viewPage = false;
               const code = isLoggingIn.code;
               const state = isLoggingIn.state;
               if (code !== null && state != null) {
                    this.viewPage = false;
                    // call api to get token and redirect
                    window.location.href = `${environment.APP_API_URL}/api/OIDCAuthentication/SignInCallback?state=${state}&code=${code}`;
               }
          }
        
          // //check if the user is returning from CCP checkout (driver record request)
          // const returnFromCCP = this.generalService.getReturnFromCCP();
          // if (returnFromCCP) {
          //      this.viewPage = false;
          //      window.location.href = `${environment.APP_PSP_BASE_URL}/${returnFromCCP}`;
          // }
        
          if (isLoggingIn === null){
               //&& returnFromCCP === null) {
               // clear local storage if landing on home and not logging in, clearing old token info in browswer. 
               // Don't do this before checking for other local storage items. 
               localStorage.clear();
          }

          setTimeout(() => this.scrollToTop(), 500);
     }

     async redirectToLoginGov() {
          this.isLoading = true;
          let authCode = '';
          await this.generalService.getLoginGovUrl(authCode).toPromise().then((response: string) => {
               this.loginGovUrl = response;
          });

          window.location.href = this.loginGovUrl;
     }

     ngOnDestroy() {
          
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
